import { ruPlural } from '@/lib/content/declension';

/**
 * UI-тексты листингов блога: главная (GfBlogHome), страница категории
 * (GfBlogCategory) и страница тега (GfBlogTag). Только UI-обвязка листингов,
 * НЕ тело статей. Интерполируемые строки — функции; склонения и формат чисел
 * остаются в компонентах. RU и EN имеют одинаковую форму ключей.
 */
export const blogUi = {
    en: {
        journal: 'Journal',
        mastTitle: "Traveller's journal",
        mastSub:
            'Stories, tips and practical guides for independent trips — from connectivity and transport to stays and tours.',
        // Filter bar
        filtersAria: 'Blog filters',
        categoriesAria: 'Blog categories',
        all: 'All',
        searchPlaceholder: 'Search articles…',
        searchAria: 'Search articles',
        countryAria: 'Country',
        allCountries: 'All countries',
        filterByCountry: 'Filter by country',
        // Section marks / headings
        category: 'Category',
        articles: 'Articles',
        latest: 'Latest articles',
        categoryKick: 'Category · Journal',
        sectionLabel: 'Section · ',
        articlesWord: 'articles',
        // Back link
        backAll: '← All articles',
        // Dynamic
        articlesCount: (n) => `${n} ${n === 1 ? 'article' : 'articles'}`,
        searchHeading: (q) => `Search: "${q}"`,
        articlesOf: (title) => `Articles: ${title}`,
        tagDesc: (name) => `All journal posts tagged "${name}".`,
        // Empty states
        nothingFound: 'Nothing found — adjust the filters or query.',
        emptyCategory: 'No articles in this category yet.',
        emptyTag: 'No articles with this tag yet.',
    },
    ru: {
        journal: 'Журнал',
        mastTitle: 'Журнал путешественника',
        mastSub:
            'Истории, советы и практические гайды для самостоятельных поездок — от связи и транспорта до жилья и экскурсий.',
        filtersAria: 'Фильтры блога',
        categoriesAria: 'Категории блога',
        all: 'Все',
        searchPlaceholder: 'Поиск статей…',
        searchAria: 'Поиск статей',
        countryAria: 'Страна',
        allCountries: 'Все страны',
        filterByCountry: 'Фильтр по стране',
        category: 'Категория',
        articles: 'Статьи',
        latest: 'Последние статьи',
        categoryKick: 'Категория · Журнал',
        sectionLabel: 'Раздел · ',
        articlesWord: 'статей',
        backAll: '← Все статьи',
        articlesCount: (n) => `${n} ${ruPlural(n, ['статья', 'статьи', 'статей'])}`,
        searchHeading: (q) => `Поиск: «${q}»`,
        articlesOf: (title) => `Статьи: ${title}`,
        tagDesc: (name) => `Все материалы журнала с тегом «${name}».`,
        nothingFound: 'Ничего не найдено — измените фильтры или запрос.',
        emptyCategory: 'Пока нет статей в этой категории.',
        emptyTag: 'Статей с этим тегом пока нет.',
    },
};
